// Legacy WordPress URLs that have no direct successor on the new site.
// Everything else keeps its original slug, so no redirect is needed.

const EXACT: Record<string, string> = {
  "/kcn-brand-shop": "/meet-the-team",
  "/upcoming-classes": "/round-table",
  "/team-events": "/round-table",
  "/careers": "/why-join-kcn",
  "/contact": "/contact-us",
  "/about": "/meet-the-team",
  "/locations": "/kcn-worldwide",
  "/why-join": "/why-join-kcn",
  "/request-invite": "/kcn-join-our-team",
  "/coaching-training": "/coaching-and-training",
  "/technology-tools": "/technology-and-tools",
  "/growth-team-building": "/growth-and-team-building",
  "/marketing-strategy": "/marketing-content-and-strategy",
  "/sales-leads-referrals": "/sales-leads-and-referrals",
};

const PREFIXES: Array<[string, string]> = [
  ["/kw_agents/", "/meet-the-team"],
  ["/cat_kw_agents/", "/meet-the-team"],
  ["/author/", "/blog"],
  ["/careers/", "/why-join-kcn"],
  ["/tag/", "/blog"],
  ["/category/", "/blog"],
];

/** Returns the destination path for a retired legacy URL, or null. */
export function resolveLegacyRedirect(pathname: string): string | null {
  const clean = ("/" + pathname.replace(/^\/+/, "")).replace(/\/+$/, "") || "/";
  if (EXACT[clean]) return EXACT[clean];
  const withSlash = clean + "/";
  for (const [prefix, target] of PREFIXES) {
    if (withSlash.startsWith(prefix)) return target;
  }
  return null;
}
